module.exports = __webpack_public_path__ + "static/media/Portrait-10046.aeaf61fb.jpg";